import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Async from 'components/Async';

import useModel from '@common/helpers/useModel';
import CurrentLearningFlowModel, {
	ICurrentLearningFlowModel,
} from '@common/models/CurrentLearningFlow/CurrentLearningFlow';
import { IStudentSimpleProgramModel } from '@common/models/StudentPrograms/StudentSimpleProgram';

import {
	Direction,
	Label,
	// PaymentCard,
	Wrapper,
} from './styled';

// const NEXT_PAYMENT_MOCK = {
// 	date: '18 Aug 2026',
// 	amount: '$49',
// } as const;

interface CurrentLearningFlowProps {
	programs: IStudentSimpleProgramModel[];
}

function CurrentLearningFlow({ programs }: CurrentLearningFlowProps) {
	const { t } = useTranslation();
	const model = useModel(CurrentLearningFlowModel, {}, [], {
		disableFetch: true,
	}) as ICurrentLearningFlowModel;

	useEffect(() => {
		model.fetch();
	}, [model]);

	if (model.hasError) {
		return null;
	}

	const activeCredits = programs.filter((program) => !program.is_blocked).length;

	return (
		<Async loading={model.loading} sx={{ minHeight: '96px', marginBottom: '24px' }}>
			<Wrapper>
				{/* <PaymentCard>
					<Typography variant="body2" fontWeight={700} >
						{t('programs.currentLearningFlow.instalmentPlan')}
					</Typography>
					<Typography
						variant="body2"
						dangerouslySetInnerHTML={{
							__html: t('programs.currentLearningFlow.nextCharge', {
								date: NEXT_PAYMENT_MOCK.date,
								amount: NEXT_PAYMENT_MOCK.amount,
							}),
						}}
					/>
				</PaymentCard> */}
				<Direction>
					<Label>{t('programs.currentLearningFlow.currentDirection')}</Label>
					<Typography component="h3" variant="h3" color="text.primary">
						{t('programs.currentLearningFlow.directionTitle', {
							direction: model.study_direction,
							grade: model.entry_grade,
						})}
					</Typography>
					<Typography component="p" variant="body2" color="text.secondary">
						{t('programs.currentLearningFlow.creditsActive', {
							active: activeCredits,
							total: programs.length,
						})}
					</Typography>
				</Direction>
			</Wrapper>
		</Async>
	);
}

export default observer(CurrentLearningFlow);
